/** @format */
import { css } from 'styled-components';

type HeartStylesProps = {
    // eslint-disable-next-line @typescript-eslint/naming-convention -- Legacy code: do not use as an example.
    $isToggled: boolean;
    // eslint-disable-next-line @typescript-eslint/naming-convention -- Legacy code: do not use as an example.
    $isHover: boolean;
};

const baseStyles = ({ $isToggled, $isHover }: HeartStylesProps) => css`
    .heart-inner {
        position: absolute;
        align-self: center;
        opacity: ${$isToggled ? 1 : 0};
    }

    ${
        !$isToggled &&
        css`
            @media (hover: hover) and (pointer: fine) {
                .heart-inner {
                    opacity: ${$isHover ? 1 : 0};
                    transition-property: opacity;
                    transition-duration: var(--animations-default-duration);
                    transition-timing-function: var(
                        --animations-default-timing-function
                    );
                }
            }
        `
    }

    .heart-outline {
        position: absolute;
        align-self: center;
        overflow: visible;
    }

    .heart-waves {
        opacity: 0;
        position: absolute;
        align-self: center;

        path {
            stroke-width: 2px;
            stroke: white;
            stroke-linecap: round;
        }
    }
`;

/* eslint-disable @mpb-com/mpb/use-design-tokens -- Legacy code: do not use as an example. */
const toggledStyles = css`
    @keyframes heartPulse {
        0% {
            transform: scale(1);
        }
        33% {
            transform: scale(0.75);
        }
        66% {
            transform: scale(1.25);
        }
        100% {
            transform: scale(1);
        }
    }

    @keyframes heartWaves {
        0% {
            opacity: 0;
            transform: scale(0);
        }
        50% {
            transform: scale(3);
            opacity: 1;
        }
        100% {
            opacity: 0;
            transform: scale(1.5);
        }
    }

    .heart-waves {
        animation: 0.7s ease-out 0s 1 heartWaves forwards;
    }

    .heart-outline,
    .heart-inner {
        animation: 0.5s ease-out 0s 1 heartPulse forwards;
        opacity: 1;
    }
`;
/* eslint-enable @mpb-com/mpb/use-design-tokens -- Legacy code: do not use as an example. */

export const styles = (props: HeartStylesProps) => css`
    ${baseStyles(props)}
    ${props.$isToggled && toggledStyles}
`;
